module.exports = __webpack_public_path__ + "static/media/customMinus.b7d93de0.svg";